var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsleFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "#E31D1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_8710",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -3,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_8710)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09358 1.14023C2.0859 1.04771 2.1966 1.00284 2.25922 1.07139C2.70835 1.56304 3.8954 2.78702 4.58188 2.78702C5.44089 2.78702 8.81448 -0.0556246 9.81164 0.407447C10.8088 0.870519 12.8277 5.71215 12.8277 5.71215L11.5121 7.36242L9.81164 6.43479L9.49026 2.78702C9.49026 2.78702 6.21721 4.4705 4.58188 3.85943L3.6626 4.6319C3.6626 4.6319 2.77731 2.87889 2.4287 2.34272C2.19803 1.98795 2.11999 1.45813 2.09358 1.14023Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26195 5.12388L3.70216 5.46305L3.80907 4.74468L3.35618 4.23594L3.98205 4.13113L4.26195 3.47754L4.54185 4.13113L5.16772 4.23594L4.71484 4.74468L4.82175 5.46305L4.26195 5.12388Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0127 0.791424C9.0127 0.591103 9.17509 0.428711 9.37541 0.428711C9.57573 0.428711 9.73812 0.591103 9.73812 0.791424V2.50502C9.73812 2.70534 9.57573 2.86774 9.37541 2.86774C9.17509 2.86774 9.0127 2.70534 9.0127 2.50502L9.0127 0.791424Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2212 2.10294C21.3038 2.14546 21.2831 2.26312 21.1918 2.27989C20.5369 2.40024 18.8698 2.75831 18.5061 3.34048C18.0509 4.06896 18.6738 8.4363 17.7527 9.03654C16.8316 9.63679 11.6558 8.78324 11.6558 8.78324L10.9535 6.79301L12.6412 5.84254L15.905 7.50302C15.905 7.50302 16.2118 3.8352 17.5966 2.77219L17.4287 1.58325C17.4287 1.58325 19.3844 1.76143 20.0239 1.74992C20.447 1.7423 20.9376 1.95687 21.2212 2.10294Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6939 1.83172L16.7029 1.17726L17.2554 1.6486L17.9269 1.53413L17.6841 2.12043L18.09 2.70415L17.3874 2.59517L16.9669 3.0704L16.7755 2.41673L16.1096 2.12672L16.6939 1.83172Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9155 8.20428C18.0951 8.31569 18.154 8.54948 18.0486 8.7327C17.9356 8.92925 17.6798 8.98913 17.4913 8.8632L15.9427 7.82891C15.8038 7.7361 15.7468 7.55997 15.8051 7.40336C15.8845 7.18998 16.1394 7.10277 16.3329 7.22278L17.9155 8.20428Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8629 17.9863C10.7849 18.0365 10.6933 17.9599 10.7244 17.8724C10.9477 17.245 11.4711 15.6223 11.1488 15.0162C10.7455 14.2577 6.6518 12.6135 6.59253 11.5157C6.53326 10.4179 9.86036 6.36228 9.86036 6.36228L11.9351 6.74917L11.9144 8.68604L8.84444 10.6823C8.84444 10.6823 11.8675 12.7819 12.0957 14.5127L13.2093 14.9617C13.2093 14.9617 12.0771 16.5664 11.7674 17.1259C11.5624 17.4961 11.1312 17.8138 10.8629 17.9863Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.362 14.2016L13.9243 14.5367L13.2398 14.7795L13.0032 15.4182L12.6168 14.9148L11.9084 14.9745L12.354 14.4206L12.1527 13.8187L12.8146 13.9798L13.3986 13.5481L13.362 14.2016Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10357 11.9596C6.8805 12.0448 6.63243 11.9202 6.56747 11.6905C6.51053 11.489 6.61586 11.2773 6.81085 11.2012L8.47913 10.5502C8.6645 10.4779 8.87509 10.548 8.98016 10.7169C9.11732 10.9375 9.01931 11.2284 8.77664 11.3211L7.10357 11.9596Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66276 6.76465C9.5383 6.72116 9.47183 6.58255 9.51428 6.45506C9.55673 6.32757 9.75612 6.11461 9.88057 6.1581L11.6164 6.76465C11.7059 6.79594 11.7689 6.87859 11.7768 6.97519L11.932 8.87904C11.9429 9.01328 11.7474 9.12187 11.6164 9.13308C11.4853 9.14429 11.3702 9.04456 11.3593 8.91032L11.2156 7.27307L9.66276 6.76465Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6804 5.76761C12.7841 5.68485 12.9694 5.78077 13.0502 5.88705C13.131 5.99334 13.1124 6.14659 13.0086 6.22934L11.8062 7.46176C11.7024 7.54452 11.4691 7.38309 11.3883 7.27681C11.3075 7.17053 11.2846 6.881 11.3883 6.79824L12.6804 5.76761Z",
    fill: "#FECA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsleFlagIcon);
export default __webpack_public_path__ + "static/media/isleFlagIcon.3cacab81cda30277fc28b60a62b9e124.svg";
export { ForwardRef as ReactComponent };